<template>
  <div>{{ row.address }}</div>
</template>

<script>
export default {
  name: 'tdAddress',
  props: ['row']
};
</script>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdAddress.vue